import Vue from "vue";

export default Vue.extend({
  data: () => ({
    showFilters: false as boolean,
    activeFilters: 0 as number
  }),

  methods: {
    toggleFilters(): void {
      this.showFilters = !this.showFilters;
    },
    getAvailableFilters(filter: { [value: string]: any }) {
      const newFilters: { [value: string]: any } = {};

      for (const key in filter) {
        if (Array.isArray(filter[key]) && !filter[key].length) {
          continue;
        }
        if (filter[key]) {
          newFilters[key] = filter[key];
        }
      }

      return { ...newFilters };
    },
    async applyFilters(): Promise<void> {
      try {
        if (Object.keys(this.filter).length) {
          const filterString = new URLSearchParams(
            this.getAvailableFilters(this.filter) as any
          ).toString();
          await this.$router.push(
              // @ts-ignore
              `/${this.$route.meta.module}/page/${this.pagination.number}?${filterString}&`
          );
          this.pagination.number = 1;
          this.filter = this.getAvailableFilters(this.filter);
        }
        this.changeActiveFilters();

        await this.loadData();
      } catch {
        await Promise.resolve();
      }
    },
    changeActiveFilters() {
      this.activeFilters = Object.keys(this.filter).length;
    },
    resetFilters(): void {
      this.filter = {};
      try {
        this.$router.push(
            // @ts-ignore
            `/${this.$route.meta.module}/page/${this.pagination.number}`
        );
        this.applyFilters();
      } catch {
        Promise.resolve();
      }
    }
  }
});
